// extracted by mini-css-extract-plugin
module.exports = {"studioPage":"Studio_studioPage_OJ3I2","form":"Studio_form_2KQwn","overlay":"Studio_overlay_1nFy2","displayOverlay":"Studio_displayOverlay_2IS8W"};